import * as d3 from 'd3';
import * as _ from 'lodash';

import { Alias, VariableType, VariableSubType, AliasBinding, VariableTableViewModel } from '../../../models/index';
import { guidEmpty } from '../../../common/index';

const _emptyAlias: Alias = { guid: guidEmpty, name: '' } as Alias;

export function mapForTable(variables: VariableType[], defaultAliases: Alias[], customAliases: Alias[],
    subTypes: VariableSubType[], bindings: AliasBinding[]): VariableTableViewModel[] {
    let result: VariableTableViewModel[] = [];
    variables.forEach(v => {
        v.unitCollection.forEach(u => {
            if (v.variableSubTypeGuidCollection.length) {
                v.variableSubTypeGuidCollection.forEach(st => {
                    const curDefaultAliases = defaultAliases.filter(a => a.variableTypeGuid === v.guid && a.unitGuid === u.guid && a.variableSubTypeGuid === st);
                    const curCustomAliases = customAliases.filter(a => a.variableTypeGuid === v.guid && a.unitGuid === u.guid && a.variableSubTypeGuid === st);
                    const subtype = _.find(subTypes, s => s.guid === st);
                    const binding = findBinding(v.guid, subtype.guid, u.guid, bindings);
                    result.push({
                        guid: v.guid,
                        name: v.name,
                        unit: u.name,
                        unitGuid: u.guid,
                        unitComment: u.longComment,
                        subType: subtype.name,
                        subTypeGuid: st,
                        defaultAliases: curDefaultAliases,
                        customAliases: curCustomAliases,
                        combinedAliases: [_emptyAlias].concat(curDefaultAliases).concat(curCustomAliases),
                        reportingAlias: binding ? binding.aliasGuid : guidEmpty,
                        aliasBindingGuid: binding ? binding.guid : guidEmpty
                    });
                });
            } else {
                const curDefaultAliases = defaultAliases.filter(a => a.variableTypeGuid === v.guid && a.unitGuid === u.guid);
                const curCustomAliases = customAliases.filter(a => a.variableTypeGuid === v.guid && a.unitGuid === u.guid);
                const binding = findBinding(v.guid, guidEmpty, u.guid, bindings);
                result.push({
                    guid: v.guid,
                    name: v.name,
                    unit: u.name,
                    unitGuid: u.guid,
                    unitComment: u.longComment,
                    subType: '',
                    subTypeGuid: '',
                    defaultAliases: curDefaultAliases,
                    customAliases: curCustomAliases,
                    combinedAliases: [_emptyAlias].concat(curDefaultAliases).concat(curCustomAliases),
                    reportingAlias: binding ? binding.aliasGuid : guidEmpty,
                    aliasBindingGuid: binding ? binding.guid : guidEmpty
                });
            }
        });
    });
    result = _.sortBy(result, [
        (d: VariableTableViewModel) => d.name.toLowerCase(),
        (d: VariableTableViewModel) => d.subType.toLowerCase(),
        (d: VariableTableViewModel) => d.unit.toLowerCase()
    ]);
    return result;
}

function findBinding(vtGuid: string, vstGuid: string, unitGuid: string,
    bindings: AliasBinding[]): AliasBinding {
    return _.find(bindings, b => b.unitGuid === unitGuid
        && b.variableTypeGuid === vtGuid
        && b.variableSubTypeGuid === vstGuid);
}

export function toHierarchy(value: VariableTableViewModel[]): { key: string, values: VariableTableViewModel[] }[] {
    return d3.nest<VariableTableViewModel>()
        .key(d => d.name)
        .entries(value);
}